import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from 'store/store';
import { AppWrapper } from 'App';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import SharedWrapper from 'components/shared/SharedWrapper';

declare global {
    interface Window {
        MiNamespace: any;
    }
}

window.MiNamespace = {
    render: (params: any) => {
        document.dispatchEvent(
            new CustomEvent('mi-render', {
                bubbles: false,
                detail: params,
            }),
        );
    },
};

let sharedInitialized = false;

function initShared() {
    if (sharedInitialized) return;
    sharedInitialized = true;

    document.addEventListener('mi-render', (e: any) => {
        if (e instanceof CustomEvent && e.detail) {
            let containerId = '';
            if (e.detail.containerId && document.getElementById(e.detail.containerId))
                containerId = e.detail.containerId;
            else {
                containerId = 'miContainer_' + new Date().valueOf() + Math.floor(Math.random() * 1000);
                const container = document.createElement(e.detail.containerType ? e.detail.containerType : 'div');
                container.id = containerId;
                document.body.appendChild(container);
            }

            //@ts-ignore
            const root = createRoot(document.getElementById(containerId));
            const router = createBrowserRouter([
                {
                    path: '*',
                    element: <SharedWrapper e={e} />,
                    loader: (args) => {
                        if (
                            args &&
                            args.params &&
                            args.params['*'] &&
                            document.location.pathname != '/' + args.params['*']
                        ) {
                            document.location.href = document.location.origin + '/' + args.params['*'];
                        }

                        return args;
                    },
                },
            ]);
            root.render(
                <Provider store={store}>
                    <AppWrapper>
                        <RouterProvider router={router} />
                    </AppWrapper>
                </Provider>,
            );
        }
    });
}

export default initShared;
